(function ($) {
	var pauseStickyCheck = false;

	stickyHeaderCheck();

    $(window).scroll(function () {
		stickyHeaderCheck();
    });

    $('.scroller a').click(function(e) {
    	forceSticky();
    });

    function stickyHeaderCheck() {
    	if (pauseStickyCheck) return;

    	$('header').toggleClass('is-sticky', $(document).scrollTop() > 120);

        if ($(document).scrollTop() < 120) {
            $('.logo-link img.desktop').attr('src','/wp-content/themes/gff/assets/images/logo.svg');
        }

        if ($(document).scrollTop() > 120) {
            $('.logo-link img.desktop').attr('src','/wp-content/themes/gff/assets/images/logo-sm.svg');
        }
    }

    function forceSticky() {
    	$('header').addClass('is-sticky');
    	$('.logo-link img.desktop').attr('src','/wp-content/themes/gff/assets/images/logo-sm.svg');

    	pauseStickyCheck = true;

    	window.setTimeout(function() {
    		pauseStickyCheck = false;
    	}, 850);
    }
})(jQuery);